import React from "react";

export const WarehouseDetailContext = React.createContext(null);

export const useWarehouseDetailContext = () => {
  const context = React.useContext(WarehouseDetailContext);

  if (!context) throw new Error("Warehouse Detail Context not provided!");

  return context;
};
